if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('quantityChange', { bubbles: true });

      this.continueWhenOverMax = parseInt(this.input.getAttribute('data-continue-max'));

      this.input.addEventListener('change', this.onValueChange.bind(this));
      this.input.addEventListener('input', this.onValueChange.bind(this));

      this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
    }

    onValueChange() {
      const val = parseInt(this.input.value);

      // Prevent value going over max
      if (this.input.hasAttribute('max')) {
        const max = parseInt(this.input.getAttribute('max'));
        if (val > max) {
          this.input.value = max;
        }
      }
      // Dispatch change event for cart updates
      this.input.dispatchEvent(this.changeEvent);

      this.handleButtonState();

      this.updateDeliveryMessages(val);
    }

    /**
     * Updates the delivery messages on PDP based on the quantity value
     * @param {number} val - The current quantity value
     */
    updateDeliveryMessages(val) {
      this.mainProduct = this.mainProduct || this.closest('main-product');
      if (!this.mainProduct) {
        return;
      }
      this.deliveryMessages = this.deliveryMessages || this.mainProduct.querySelectorAll('[data-delivery-message-original]');

      if (this.continueWhenOverMax && this.deliveryMessages.length > 0) {
        const originalDeliveryStr = this.deliveryMessages[0].getAttribute('data-delivery-message-original');
        const delayedDeliveryStr = this.deliveryMessages[0].getAttribute('data-delivery-message-delayed');

        if (originalDeliveryStr && delayedDeliveryStr) {
          let deliveryMessage = originalDeliveryStr;
          if (val > this.continueWhenOverMax) {
            deliveryMessage = delayedDeliveryStr;
          }
          this.deliveryMessages.forEach((message) => {
            message.textContent = deliveryMessage;
          });
        }
      }
    }

    handleButtonState() {
      this.plus = this.querySelector('button[name="plus"]');

      if (this.input.hasAttribute('max')) {
        const max = parseInt(this.input.getAttribute('max'));
        const val = parseInt(this.input.value);

        if (val >= max) {
          this.plus.disabled = true;
        } else {
          this.plus.removeAttribute('disabled');
        }
      }
    }

    onButtonClick(event) {
      event.preventDefault();
      this.input.value;

      // Change the value (triggers change event)
      event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      this.onValueChange();
    }
  }

  customElements.define('quantity-input', QuantityInput);
}
